import { render, staticRenderFns } from "./InternationalShipping.vue?vue&type=template&id=1e8c26ca&scoped=true"
import script from "./InternationalShipping.vue?vue&type=script&lang=js"
export * from "./InternationalShipping.vue?vue&type=script&lang=js"
import style0 from "./InternationalShipping.vue?vue&type=style&index=0&id=1e8c26ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c26ca",
  null
  
)

export default component.exports